import { useEffect, useState } from 'react';
import { BaseUserInfo } from '../interface/BaseUserInfo';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import api from '../api/CallManagerApi';
import reportApi from '../api/CallCreateReportApi';
import { useParams } from 'react-router-dom';
import { startLoading, stopLoading } from '../../store/loadingReducer';
import { useDispatch } from 'react-redux';
import SmallMediaCategory from '../components/InputSmallMediaCategory';
import { setSmallMediaCategorySelected, DANCE_TITLE, THEATER_TITLE } from '../utils';
import HelpArea from '../components/HelpComponent';
import { getRequiredBigMediaCategoryTmpById, getMediaCategoryTmpById } from '../localStorageUtils';
import { MediaCategory } from '../interface/MediaCategory';
import { useErrorBoundary } from 'react-error-boundary';
import Axios from 'axios';

const RegisterSmallMediaCategory: React.FunctionComponent = () => {
  const [userInfo, setUserInfo] = useState<BaseUserInfo>({} as BaseUserInfo);
  const [mediaCategoryData, setMediaCategoryData] = useState<MediaCategory[]>([]);
  const [selectedMediaCategory, setSelectedMediaCategory] = useState<string>('');
  const [bigMediaCategory, setBigMediaCategory] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [reportId, setReportId] = useState<string>('');
  const params = useParams();
  const [helps, setHelps] = useState<any[]>([]);
  const { showBoundary } = useErrorBoundary();

  const nextPage = (): void => {
    navigate('/manager/report/edit/' + reportId + '/media');
  };

  useEffect(() => {
    const getData = async () => {
      try {
        dispatch(startLoading());
        const profile: BaseUserInfo = await api.getProfile();
        setUserInfo(profile);
        const prevBigMediaCategory = getRequiredBigMediaCategoryTmpById(profile._id);
        setBigMediaCategory(prevBigMediaCategory);
        const data = await reportApi.getMediaCategory(prevBigMediaCategory);
        setMediaCategoryData(setSmallMediaCategorySelected(data[0].children, selectedMediaCategory));

        const id = params ? params.reportId : '';
        if (!id) throw Error('report id パラメータが存在しません');
        setReportId(id);
        const prevMediaCategory = getMediaCategoryTmpById(profile._id);
        if (prevMediaCategory) {
          setSelectedMediaCategory(prevMediaCategory);
          return;
        }
        const report = await api.getReport(id);
        const categories = report.media.categories;
        if (categories[0] === DANCE_TITLE || categories[0] === THEATER_TITLE) categories.shift();
        setSelectedMediaCategory(String(categories));
      } catch (e) {
        if (!Axios.isAxiosError(e)) showBoundary(e);
      } finally {
        dispatch(stopLoading());
      }
    };
    getData();
  }, []);

  return (
    <>
      <Container>
        <Row>
          <Col md={9} lg={9}>
            <SmallMediaCategory
              bigMediaCategory={bigMediaCategory}
              movePage={nextPage}
              mediaCategory={mediaCategoryData}
              selectedMediaCategoryByUpperLayer={selectedMediaCategory}
              userInfo={userInfo}
              setDisplayHelpData={setHelps}
            />
          </Col>
          <HelpArea helps={helps} />
        </Row>
      </Container>
    </>
  );
};
export default RegisterSmallMediaCategory;
